import { render, staticRenderFns } from "./VideoWithText.vue?vue&type=template&id=5e3c3876&scoped=true&"
import script from "./VideoWithText.vue?vue&type=script&lang=ts&"
export * from "./VideoWithText.vue?vue&type=script&lang=ts&"
import style0 from "./VideoWithText.vue?vue&type=style&index=0&id=5e3c3876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c3876",
  null
  
)

export default component.exports